import React, { useState } from "react";
import { User } from "@/types/User.tsx";
import { isBitramp } from "@/utils/utils";

interface MembersProps {
  members: User[];
  handleDeleteUserFromGroup: (userId: number) => void;
  handleAddMembers: () => void;
}

const Members: React.FC<MembersProps> = ({
  members,
  handleDeleteUserFromGroup,
  handleAddMembers,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredMembers = members.filter(
    (member) =>
      member.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`flex flex-1 mt-5 flex-col border Container  ${
        isBitramp()
          ? "border-[#464646] !bg-[#2B2B2B]"
          : "border-[#b2b2b2] bg-transparent"
      }`}
    >
      <div
        className={`flex justify-between items-center px-8 py-2.5 border-b-[1px] ${
          isBitramp() ? "border-[#464646]" : "border-[#b2b2b2]"
        }`}
      >
        <p className="Text semi-bold dark-blue">Group Members</p>
        <svg
          onClick={handleAddMembers}
          className="cursor-pointer"
          width="15"
          height="15"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.246953 8.297H8.43695V0.107H11.557V8.297H19.747V11.417H11.557V19.646H8.43695V11.417H0.246953V8.297Z"
            fill={`${isBitramp() ? "#ffffff" : "black"}`}
          />
        </svg>
      </div>

      <div className="relative mt-2 w-full px-8 py-2.5">
        <div className="absolute inset-y-0 left-8 flex items-center pointer-events-none">
          <svg
            className="ml-2"
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.6146 18.0419L15.8489 14.2873C17.0639 12.7395 17.7231 10.8281 17.7207 8.86035C17.7207 7.10794 17.201 5.39488 16.2275 3.9378C15.2539 2.48073 13.8701 1.34508 12.2511 0.674457C10.632 0.00383902 8.85052 -0.171625 7.13178 0.170253C5.41304 0.512131 3.83428 1.356 2.59514 2.59514C1.356 3.83428 0.512131 5.41304 0.170253 7.13178C-0.171625 8.85052 0.00383902 10.632 0.674457 12.2511C1.34508 13.8701 2.48073 15.2539 3.9378 16.2275C5.39488 17.201 7.10794 17.7207 8.86035 17.7207C10.8281 17.7231 12.7395 17.0639 14.2873 15.8489L18.0419 19.6146C18.1448 19.7184 18.2673 19.8008 18.4023 19.857C18.5373 19.9132 18.682 19.9422 18.8282 19.9422C18.9744 19.9422 19.1192 19.9132 19.2542 19.857C19.3891 19.8008 19.5116 19.7184 19.6146 19.6146C19.7184 19.5116 19.8008 19.3891 19.857 19.2542C19.9132 19.1192 19.9422 18.9744 19.9422 18.8282C19.9422 18.682 19.9132 18.5373 19.857 18.4023C19.8008 18.2673 19.7184 18.1448 19.6146 18.0419ZM2.21509 8.86035C2.21509 7.54604 2.60483 6.26125 3.33502 5.16844C4.06521 4.07563 5.10306 3.22389 6.31732 2.72093C7.53158 2.21797 8.86772 2.08637 10.1568 2.34278C11.4458 2.59918 12.6299 3.23208 13.5593 4.16144C14.4886 5.0908 15.1215 6.27487 15.3779 7.56392C15.6343 8.85297 15.5027 10.1891 14.9998 11.4034C14.4968 12.6176 13.6451 13.6555 12.5523 14.3857C11.4594 15.1159 10.1747 15.5056 8.86035 15.5056C7.09791 15.5056 5.40767 14.8055 4.16144 13.5593C2.91521 12.313 2.21509 10.6228 2.21509 8.86035Z"
              fill={`${isBitramp() ? "#9F9F9F" : "black"}`}
              fillOpacity="0.19"
            />
          </svg>
        </div>

        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search"
          className={`w-full pl-9 pr-4 py-2 rounded-md border placeholder:text-[rgba(159, 159, 159, 0.32)] border-gray-300 bg-white text-gray-700 placeholder-gray-400 Input ${
            isBitramp() ? "!bg-[#464646]" : ""
          }`}
        />
      </div>

      <div className="px-8 pb-3">
        <div
          className={`flex  flex-col gap-2 pb-3 min-h-[25rem] max-h-[25rem] overflow-y-auto ${
            isBitramp() ? "crypto-list_bitramp" : "crypto-list"
          }`}
        >
          {filteredMembers.map((member) => (
            <div
              key={member.id}
              className="flex justify-between items-center p-1"
            >
              <p className="Text dark-blue medium">
                {member?.first_name?.length === 0 ? "N/A" : member.first_name} -{" "}
                {member.email}
              </p>
              <svg
                onClick={() => handleDeleteUserFromGroup(member.id)}
                className="cursor-pointer"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3544_10313)">
                  <path
                    d="M16.6946 4.75098C16.7186 4.84503 16.665 4.93189 16.6599 5.01562C16.423 8.85068 16.1645 12.6836 15.8838 16.5139C15.8426 17.0748 15.9084 17.6294 15.5754 18.1343C15.2434 18.6377 14.6782 18.9383 14.0472 19.0001H3.98896C3.24391 18.9445 2.59166 18.5496 2.30315 17.9056C2.1044 17.4619 2.15232 17.0114 2.11891 16.5452C1.84256 12.7148 1.57092 8.88193 1.34282 5.04687C1.33742 4.95532 1.28107 4.85565 1.30806 4.75098H16.695H16.6946ZM5.95586 6.75849C5.40888 6.81536 5.06841 7.21061 5.01847 7.70273V16.0474C5.14636 17.2763 6.94352 17.3035 7.10954 16.0759L7.11258 7.70304C7.06196 7.14406 6.57977 6.69381 5.95552 6.7588L5.95586 6.75849ZM11.8272 6.75849C11.3082 6.81255 10.937 7.1953 10.8898 7.67148V16.0474C11.0167 17.2779 12.8138 17.3029 12.9809 16.0756L12.9839 7.70273C12.9336 7.14843 12.4423 6.69444 11.8268 6.75849H11.8272Z"
                    fill={`${isBitramp() ? "#464646" : "#D8D8D8"}`}
                  />
                  <path
                    d="M12.5129 1.18576L17.3531 1.18764C17.7077 1.21732 17.9395 1.44479 17.9743 1.76849C18.0063 2.06751 18.0107 2.71928 17.9743 3.01487C17.9375 3.3142 17.7036 3.52104 17.3838 3.56166L0.614043 3.56447C0.297869 3.52292 0.0626781 3.30982 0.0265728 3.01487C-0.0088576 2.72553 -0.0088576 2.02657 0.0265728 1.73724C0.0663898 1.41448 0.334311 1.2017 0.681192 1.18732L5.47105 1.19014L5.96269 0.329014C6.1449 0.134043 6.38448 0.0409314 6.65678 0.00312454L11.2793 0C11.7878 0.033745 11.9926 0.239964 12.2204 0.628344C12.3253 0.807693 12.4073 1.0061 12.5126 1.18576H12.5129Z"
                    fill={`${isBitramp() ? "#464646" : "#D8D8D8"}`}
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3544_10313">
                    <rect width="18" height="19" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Members;
